import { render } from "./packet_stock.vue?vue&type=template&id=2210d706&scoped=true"
import script from "./packet_stock.vue?vue&type=script&lang=js"
export * from "./packet_stock.vue?vue&type=script&lang=js"

import "./packet_stock.vue?vue&type=style&index=0&id=2210d706&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2210d706"]])

export default __exports__